export const SEO_DEFAULTS = {
  image_src:
    'https://dom-content-vault-prod-cdn-assets.porter.in/header_logo_f22422636f.svg',
  image_alt:
    'Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!',
  title: 'Porter - Mini trucks & bikes for delivery | Packers & Movers',
  description:
    'Porter offers mini truck, bike and packers & movers services for all your logistics needs.',
} as const;
